module.exports = __webpack_public_path__ + "fadadec01ffb667b7d4174ca56a57f6b.png";